import { gql } from '@apollo/client';

export const CREATE_OR_UPDATE_NOISE_EVENT_POLICY_OVERRIDE = gql(`
  mutation CreateOrUpdateNoiseEventPolicyOverride ($input: CreateOrUpdateNoiseEventPolicyOverride!) {
    facility {
        noiseEventPolicyOverrides {
            createOrUpdateNoiseEventPolicyOverride(input: $input) {
                resourceGroupId
                override
            }
        }
    }
  }
`);
